import React, { useState } from 'react';
import BEM from '../../bem';
import { ReactComponent as CircledCheckMarkIcon } from '../../../common/images/circled-checkmark.svg';
import DotsIndicator from '../DotsIndicator';
import TaskCard from './TaskCard';
import type { Task } from 'js-sdk/src/types/Tasks';
import useFilterTasks, { type TasksFilter } from 'common/hooks/useFilterTasks';
import { useAppSelector } from 'redux-stores';

const classes = BEM.with('TasksListView');

function EmptyState() {
  return (
    <div className={classes('empty')} data-test-id="tasks-empty-state">
      <CircledCheckMarkIcon aria-hidden className={classes('empty-icon')} />
      <span className={classes('empty-text')}>No tasks found</span>
    </div>
  );
}

function TasksListView() {
  const organizationId = useAppSelector((state) => state.session.currentOrganizationId);
  const [filter, setFilter] = useState<TasksFilter>('active');

  const { tasks: filtered, isLoading } = useFilterTasks({
    filter,
    orgId: organizationId,
    skip: !organizationId,
  });

  return (
    <div className={classes('')} data-test-id="tasks-list-view">
      <div className={classes('header')}>
        <CircledCheckMarkIcon aria-hidden className={classes('header-icon')} />
        <h2 className={classes('title')}>Tasks</h2>
        <div className={classes('toggle')} data-test-id="tasks-filter-toggle">
          <button
            className={classes('toggle-btn', { active: filter === 'active' })}
            onClick={() => setFilter('active')}
            type="button"
          >
            Active
          </button>
          <button
            className={classes('toggle-btn', { active: filter === 'completed' })}
            onClick={() => setFilter('completed')}
            type="button"
          >
            Completed
          </button>
        </div>
      </div>
      {isLoading ? (
        <div className={classes('loading')}>
          <DotsIndicator />
        </div>
      ) : filtered.length === 0 ? (
        <EmptyState />
      ) : (
        <div className={classes('list')}>
          {filtered.map((task: Task) => (
            <TaskCard key={task.id} organizationId={organizationId ?? ''} task={task} />
          ))}
        </div>
      )}
    </div>
  );
}

export default TasksListView;
